<script setup lang="ts">
import BaseButton from "@/components/base/BaseButton.vue";
import { formatAmountInput } from "../../utils/format";
import { defineProps } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

defineProps({
  amount: {
    type: Number,
    default: 0,
  },
});

const store = useStore();
const { t } = useI18n();

const toPayment = () => {
  store.dispatch("togglePaymentModal", true);
};
</script>

<template>
  <div class="balance">
    <div class="balance-wrapper">
      <div class="balance-main">
        <div class="balance-main__title h3">
          <span>{{ t("account.balance.title") }}</span>
        </div>
        <div class="balance-main__amount h1">
          <span>{{ formatAmountInput(amount) }} ₽</span>
        </div>
      </div>

      <div class="balance-main__action">
        <BaseButton :title="t('account.balance.topUp')" @click="toPayment" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.balance {
  background-color: var(--color-white);
  width: 100%;
  max-width: 500px;
  height: 280px;
  border-radius: 32px;

  &-wrapper {
    padding: 20px 20px 29px 23px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  &-main {
    margin-bottom: auto;

    &__title {
      margin-bottom: 2px;
    }
  }
}
</style>
